import { render, staticRenderFns } from "./AddonModal.vue?vue&type=template&id=4b5fb681&scoped=true"
import script from "./AddonModal.vue?vue&type=script&lang=js"
export * from "./AddonModal.vue?vue&type=script&lang=js"
import style0 from "./AddonModal.vue?vue&type=style&index=0&id=4b5fb681&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5fb681",
  null
  
)

export default component.exports